import Icon from '../components/Icon.vue';
Icon.register({
  fish: {
    width: 576,
    height: 512,
    paths: [{
      d: 'M327.1 96c137.5 0 248.9 128 248.9 160s-111.4 160-248.9 160c-90 0-168.6-54.8-212.3-101.6l-87.3 66c-12.1 9.2-30.2-0.6-27.1-14.7l24.2-109.8-24.2-109.8c-3.1-14.1 15-23.8 27.1-14.7l87.3 66c43.7-46.9 122.3-101.6 212.3-101.6zM414.5 280c13.3 0 24-10.8 24-24 0-13.3-10.7-24-24-24-13.3 0-24 10.7-24 24 0 13.3 10.8 24 24 24z'
    }]
  }
});